import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import login_img from "../../assets/images/login_img.png";
import login_logo from "../../assets/images/login_logo.png";
import StatusPopup from "../../components/popups/StatusPopup";
import { forgotPassword, clearSuccess } from "../../store/slices/authSlice";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error, success } = useSelector((state) => state.auth);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(forgotPassword({ email }));
  };

  useEffect(() => {
    if (success != null) {
      setEmail("");
      setShowSuccessPopup(true);
      const timer = setTimeout(() => {
        dispatch(clearSuccess());
        setShowSuccessPopup(false);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [success, dispatch]);

  return (
    <div className="login py_14">
      <div className="container-fluid h-100">
        <div className="row h-100">
          <div className="col-md-6 h-100">
            <div className="login_image">
              <div className="content_set">
                <div className="login_text_overlay">
                  <h2>
                    Smart Accounting <br />
                    Starts Here
                  </h2>
                  <p>
                    Manage users, bank accounts, and payroll — securely and <br />
                    efficiently with UnivisionCPA.
                  </p>
                </div>
                <div className="login_content"></div>
                <div className="login_total"></div>
              </div>

              <img src={login_img} alt="Login Background" />

              {/* ✅ Add text overlay here */}


            </div>
          </div>

          <div className="col-md-6">
            <div className="login_form h-100 d-flex flex-column align-item-center justify-content-center px_50">
              <img src={login_logo} className="w-auto mw-auto mb_60" />

              <h4 className="mb_4">Forgot Password</h4>
              <p>Please provide your credentials reset password.</p>

              <form onSubmit={handleSubmit} className="common_input_forms mt_0">
                <div className="form_group">
                  <label>Email Address</label>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Enter Email Address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>

                {error && <div className="text-danger mt_20">{error}</div>}

                <div className="d-flex mt_30">
                  <div className="w-50">
                    <a href="/" className="btn_link">
                      Back to login
                    </a>
                  </div>

                  <div className="w-50">
                    <button type="submit" className="btn btn_primary px_30 ms-auto" disabled={loading}>
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Submitting
                        </>
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <StatusPopup
        show={showSuccessPopup}
        type="success"
        title="Reset Link Sent"
        message="Please check your email for the password reset link."
        handleClose={() => {
          setShowSuccessPopup(false);
          navigate("/");
        }}
        onConfirm={() => {
          setShowSuccessPopup(false);
          navigate("/");
        }}
      />
    </div>
  );
};

export default ForgotPassword;
